// extracted by mini-css-extract-plugin
export var alertIcon = "_vg-0";